var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dg-dialog", attrs: { id: "DgDialog" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            modal: _vm.modal,
            "append-to-body": _vm.appendToBody,
            "modal-append-to-body": _vm.modalAppendToBody,
            "show-close": _vm.showClose,
            title: _vm.title,
            fullscreen: _vm.fullscreen,
            top: _vm.top,
            "close-on-click-modal": _vm.closeOnClickModal,
            "close-on-press-escape": _vm.closeOnPressEscape,
            center: _vm.center,
            "lock-scroll": _vm.lockScroll,
            visible: _vm.sonVisible,
            "destroy-on-close": _vm.destroyOnClose,
            width: _vm.width,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sonVisible = $event
            },
            closed: _vm.closed,
            close: _vm.close,
          },
        },
        [
          _vm.headerTip.title && _vm.sonVisible
            ? _c(
                "div",
                [
                  _c("el-alert", {
                    staticStyle: { padding: "4px 8px" },
                    attrs: {
                      title: _vm.headerTip.title,
                      type: _vm.headerTip.type || "success",
                      description: _vm.headerTip.description,
                      closable: _vm.headerTip.closable || true,
                      center: _vm.headerTip.center || false,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.showFooterButton
            ? _c("template", { slot: "footer" }, [
                _vm.footerButtons.length
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.footerButtons, function (item, index) {
                          return [
                            item.editer === "cancel"
                              ? _c(
                                  "el-button",
                                  {
                                    key: index,
                                    style: item.style,
                                    attrs: {
                                      type: item.type || "info",
                                      icon: item.icon,
                                      size: item.size,
                                      plain:
                                        item.plain === false ? false : true,
                                      round: item.round,
                                      circle: item.circle,
                                      disabled: item.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickHandle(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(item.title || "取 消")),
                                    ]),
                                  ]
                                )
                              : item.editer === "confirm"
                              ? _c(
                                  "el-button",
                                  {
                                    key: index,
                                    style: item.style,
                                    attrs: {
                                      type: item.type || "primary",
                                      icon: item.icon,
                                      size: item.size,
                                      plain:
                                        item.plain === false ? false : true,
                                      round: item.round,
                                      circle: item.circle,
                                      disabled: item.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickHandle(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(item.title || "确 定")),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    key: index,
                                    style: item.style,
                                    attrs: {
                                      type: item.type,
                                      icon: item.icon,
                                      size: item.size,
                                      plain: item.plain,
                                      round: item.round,
                                      circle: item.circle,
                                      disabled: item.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickHandle(item)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.title))])]
                                ),
                          ]
                        }),
                      ],
                      2
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.confirm },
                          },
                          [_vm._v("确 定")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "info", plain: "" },
                            on: {
                              click: function ($event) {
                                _vm.sonVisible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                      ],
                      1
                    ),
              ])
            : _c("template", { slot: "footer" }, [_vm._t("footer")], 2),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }